/**
 * Header tab icons — BlueKeys' own, in the same navy line style as the furnish
 * "why" icons. Stays gets a key (our name), Furnish an armchair, Experiences a
 * compass. Stroke on currentColor so they follow the tab's text colour.
 */
const COMMON = {
  width: 17,
  height: 17,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.9,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  "aria-hidden": true,
};

export function StaysIcon() {
  return (
    <svg {...COMMON}>
      <circle cx="8" cy="12" r="4.5" />
      <path d="M12.5 12H21M18 12v3.5M15 12v2.5" />
    </svg>
  );
}

export function FurnishIcon() {
  return (
    <svg {...COMMON}>
      <path d="M6 11V7.5A2.5 2.5 0 0 1 8.5 5h7A2.5 2.5 0 0 1 18 7.5V11" />
      <path d="M4.5 13.5A2 2 0 0 1 6.5 11.5h0A2 2 0 0 1 8.5 13.5V15h7v-1.5a2 2 0 0 1 4 0V18a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1v-4.5Z" />
      <path d="M7 19v1.5M17 19v1.5" />
    </svg>
  );
}

export function ExperiencesIcon() {
  return (
    <svg {...COMMON}>
      <circle cx="12" cy="12" r="8.5" />
      <path d="m15.5 8.5-2 5-5 2 2-5 5-2Z" />
    </svg>
  );
}
